import { render, staticRenderFns } from "./Who.vue?vue&type=template&id=ed1532b4&scoped=true&"
import script from "./Who.vue?vue&type=script&lang=js&"
export * from "./Who.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1532b4",
  null
  
)

export default component.exports